import { render, staticRenderFns } from "./unidade-select.vue?vue&type=template&id=32b643b6&scoped=true&"
import script from "./unidade-select.vue?vue&type=script&lang=js&"
export * from "./unidade-select.vue?vue&type=script&lang=js&"
import style0 from "./unidade-select.vue?vue&type=style&index=0&id=32b643b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b643b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
